import { ChatCreateRecordAction } from "../../types/chat/ChatContent";

import { isRecord, RECORD_PARENT_ENTITY_TYPES } from "./chatWireGuards";

// EntityType's values match the wire verbatim; narrowing tests membership against the array
// this folder already uses, not a second list or mapping layer.
const parseCreateRecordAction = (
  raw: Record<string, unknown>,
  warnings: string[]
): ChatCreateRecordAction | undefined => {
  // An object, and not an array: Array.isArray passes typeof "object", and an array of values is
  // not a value bag. isRecord already excludes null.
  if (!isRecord(raw.proposedValues) || Array.isArray(raw.proposedValues)) {
    return undefined;
  }
  const proposedValues = raw.proposedValues;

  // Absent and null are the same instruction — the agent had no signal — and the backend sends
  // whichever its serializer felt like. Only a present, unrecognisable string is an error.
  if (raw.targetEntityType === undefined || raw.targetEntityType === null) {
    // The platform refuses to mint a typeless proposal carrying values, so a payload that has both
    // is a contract break we cannot render honestly: the picker would clear fields the card showed.
    if (Object.keys(proposedValues).length > 0) {
      warnings.push('"create_record" proposal has no entity type but carries proposed values');
      return undefined;
    }
    return { proposedValues, targetEntityType: null, type: "create_record" };
  }

  const targetEntityType = RECORD_PARENT_ENTITY_TYPES.find(
    (candidate) => candidate === raw.targetEntityType
  );
  if (!targetEntityType) {
    warnings.push('Unrecognised "create_record" targetEntityType');
    return undefined;
  }
  return { proposedValues, targetEntityType, type: "create_record" };
};

export default parseCreateRecordAction;
